import React from 'react'
import { Box, Loading } from '@maui/elements'

export const PageLoading = () => {
  return (
    <Box
      fontSize='1.8em'
      display='flex'
      alignItems='center'
      justifyContent='center'
      height='300px'
    >
      <Loading/>
      <Box
        fontSize='2rem'
        fontWeight='bold'
        display='inline-flex'
        flexDirection='column'
        alignItems='center'
        justifyContent='center'
        marginRight='0.5em'
      />
    </Box>
  )
}
